"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallstackTypeTag = void 0;
var SmallstackTypeTag;
(function (SmallstackTypeTag) {
    /** common types that end users would use */
    SmallstackTypeTag["COMMON"] = "common";
    /** administrative types only for admins */
    SmallstackTypeTag["ADMIN"] = "admin";
    /** linkables */
    SmallstackTypeTag["LINK_FOR_CALENDAR"] = "linkForCalendar";
    SmallstackTypeTag["LINK_FOR_TODO"] = "linkForTodo";
})(SmallstackTypeTag = exports.SmallstackTypeTag || (exports.SmallstackTypeTag = {}));
